import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import ManualCharacterContextMenu from 'app/frontend/base/components/ManualCharacterContextMenu'
import {
  useUnclaimManualCharacter,
  useUpdateManualCharacter,
} from 'app/frontend/base/config/mutations'

const ManualCharacterMenu = ({
  character,
}: {
  character: wowaudit.CharacterReference
}) => {
  const { t } = useTranslation()
  const { mutate: update, isPending: updating } = useUpdateManualCharacter()
  const { mutate: unclaim, isPending: unclaiming } = useUnclaimManualCharacter()

  return (
    <ManualCharacterContextMenu
      character={character}
      size='medium'
      busy={updating || unclaiming}
      onClassChange={(characterClass) =>
        update({ characterId: character.id, characterClass })
      }
      onRename={(values, onSuccess) =>
        update(
          { characterId: character.id, ...values },
          {
            onSuccess: () => {
              toast.success('Name changed')
              onSuccess()
            },
          },
        )
      }
      renaming={updating}
      removeLabel={t('profile.manual-characters.unclaim')}
      onRemove={() => unclaim(character.id)}
    />
  )
}

export default ManualCharacterMenu
